import { useEffect, useId, useRef, useState } from 'react';
import './reviews-carousel.css';

export default function ReviewsCarousel({ children, className }) {
  const track = useRef(null);
  const trackId = useId();
  const [positions, setPositions] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const element = track.current;
    function measure() {
      const max = element.scrollWidth - element.clientWidth;
      const cards = Array.from(element.children);
      const origin = cards[0]?.offsetLeft ?? 0;
      const stops = [...new Set(cards.map(card => Math.min(max, card.offsetLeft - origin)))];
      setPositions(stops);
      setActive(stops.reduce((closest, stop, index) =>
        Math.abs(stop - element.scrollLeft) < Math.abs(stops[closest] - element.scrollLeft) ? index : closest, 0));
    }

    measure();
    element.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(element);
    return () => {
      element.removeEventListener('scroll', measure);
      window.removeEventListener('resize', measure);
      observer?.disconnect();
    };
  }, [children]);

  function goTo(index) {
    track.current.scrollTo({ left: positions[index] });
  }

  return (
    <div className="review-carousel" role="group" aria-label="Отзывы клиентов">
      <div id={trackId} ref={track} className={`${className} review-carousel__track`}>
        {children}
      </div>
      {positions.length > 1 && (
        <div className="review-carousel__controls" role="group" aria-label="Навигация по отзывам">
          <button type="button" aria-label="Предыдущий отзыв" aria-controls={trackId} disabled={active === 0} onClick={() => goTo(active - 1)}>←</button>
          <div className="review-carousel__positions">
            {positions.map((position, index) => (
              <button key={position} type="button" aria-label={`Позиция ${index + 1} из ${positions.length}`} aria-current={index === active ? 'true' : undefined} aria-controls={trackId} onClick={() => goTo(index)} />
            ))}
          </div>
          <button type="button" aria-label="Следующий отзыв" aria-controls={trackId} disabled={active === positions.length - 1} onClick={() => goTo(active + 1)}>→</button>
        </div>
      )}
    </div>
  );
}
